import {
  initYouTubeVideo,
  initVimeoVideo,
  updateIframeVimeoVideo,
  updateIframeYouTubeVideo,
} from "./external-video-player.js"

import {
  addPlayerToTrackingArr,
  pausePlayingVideos,
} from "./video-player-state.js"

/**
 * Create new YouTube and Vimeo videos. Initialize YouTube, Vimeo and Shopify videos when triggered.
 * @param {HTMLDivElement} node video container with data to structure triggers with video player created during initialization
 */
const liquidMadeVideoPlayer = (node) => {
  const { showPoster, hasPoster } = node.dataset
  const playButton = node.querySelector("[js-poster-play-button]")

  if (showPoster && hasPoster) {
    playButton.addEventListener("click", () => {
      node.dataset.videoInitialized = "true"
      _initLiquidMadeVideoPlayer(node, { hadPoster: true })
    })

    playButton.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        node.dataset.videoInitialized = "true"
        _initLiquidMadeVideoPlayer(node, { hadPoster: true })
      }
    })
  } else {
    _initLiquidMadeVideoPlayer(node, { hadPoster: false })
  }
}

const _initLiquidMadeVideoPlayer = (node, poster) => {
  const internalVideo = node.querySelector("[data-video-internal]")
  const externalVideo = node.querySelector("[data-video-external]")

  if (externalVideo) {
    const { videoProvider } = externalVideo.dataset

    if (videoProvider === "youtube") {
      initYouTubeVideo(externalVideo, poster.hadPoster)
    } else if (videoProvider === "vimeo") {
      initVimeoVideo(externalVideo, poster.hadPoster)
    }
  } else if (internalVideo && poster.hadPoster) {
    pausePlayingVideos()
    internalVideo.play()

    // Delay adding player to arr to prevent pre-emptive pause
    setTimeout(() => {
      addPlayerToTrackingArr("internal", internalVideo)
    }, 100)
  }
}

/**
 * When triggered, append and initialize prepared YouTube, Vimeo and Shopify videos.
 * @param {HTMLDivElement} videoContainer container with data to structure triggers and initialization
 * @param {HTMLElement} video iframe (YouTube & Vimeo) or video element (Shopify) to append
 */
const domMadeVideoPlayer = (videoContainer, video) => {
  const { videoType, showPoster } = videoContainer.dataset

  if (showPoster === "true") {
    const playButton = videoContainer.querySelector("[js-poster-play-button]")

    playButton.addEventListener("click", () => {
      videoContainer.setAttribute("data-video-initialized", "true")
      videoContainer.appendChild(video)

      _initDomMadeVideoPlayer(video, videoType, { hadPoster: true })
    })

    playButton.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        videoContainer.setAttribute("data-video-initialized", "true")
        videoContainer.appendChild(video)

        _initDomMadeVideoPlayer(video, videoType, { hadPoster: true })
      }
    })
  } else {
    videoContainer.appendChild(video)
    _initDomMadeVideoPlayer(video, videoType, { hadPoster: false })
  }
}

const _initDomMadeVideoPlayer = (video, videoType, poster) => {
  if (videoType === "youtube") {
    updateIframeYouTubeVideo(video.id, poster.hadPoster)
  } else if (videoType === "vimeo") {
    updateIframeVimeoVideo(video, poster.hadPoster)
  } else {
    if (poster.hadPoster === true) {
      // Only play Shopify video element if poster removed
      pausePlayingVideos()
      addPlayerToTrackingArr("internal", video)
      video.play()
    }
  }
}

export { liquidMadeVideoPlayer, domMadeVideoPlayer }
